import { UpgradeReport } from '@/types/upgradereport';

export class UpgradeJobInfo {
    public id: string = '';

    public initiated: string = '';

    public status:string = '';

    public details:string = '';

    public reports:Array<UpgradeReport> = [];

    constructor(id:string,
      initiated:string,
      status:string,
      details:string,
      reports:Array<UpgradeReport>) {
      this.id = id;
      this.initiated = initiated;
      this.status = status;
      this.details = details;
      this.reports = reports;
    }

    static fromResponseData(data:any) {
      return new this(
        data.id,
        data.initiated,
        data.status,
        data.details,
        data.reports,
      );
    }
}

export default UpgradeJobInfo;
